import { watchEffect, reactive } from 'vue'
import uniqid from 'uniqid'
import { isClient } from '@vueuse/core'

const state = reactive({
    elements: [],
})

const fireRipple = (e, element = {}) => {
    if (isClient) {
        if (!state.elements.map((i) => i.id).includes(element.id)) return

        const rect = element.dom.getBoundingClientRect()
        const x = e.pageX - rect.left - window.scrollX
        const y = e.pageY - rect.top - window.scrollY
        const w = element.dom.offsetWidth * 1.5
        const ripple = document.createElement('span')

        if (element.color) {
            ripple.style.backgroundColor = element.color
        } else {
            ripple.style.backgroundColor = 'rgba(255,255,255,.3)'
        }

        ripple.className = 'ripple'
        ripple.style.left = `${x}px`
        ripple.style.top = `${y}px`
        ripple.style.setProperty('--scale', w)
        element.dom.appendChild(ripple)
        setTimeout(() => {
            ripple.parentNode.removeChild(ripple)
        }, 500)
    }
}

watchEffect(() => {
    Object.values(state.elements).forEach((element) => {
        element.dom.classList.add('ripple-parent')
        element.dom.addEventListener('click', (e) => fireRipple(e, element))
    })
})

const addRipple = (element, opt) => {
    const id = uniqid()
    // eslint-disable-next-line no-param-reassign
    element.dataset.rippleId = id
    let options
    if (!opt) {
        options = {}
    } else {
        options = opt
    }

    if (options.color) {
        state.elements.push({
            id,
            dom: element,
            color: options.color,
        })
    }
}

export default {
    name: 'ripple',

    logic: {
        mounted: (element, binding) => {
            addRipple(element, binding.value)
        },
        updated: (element, binding) => {
            const id = element.dataset.rippleId
            state.elements = state.elements.filter((e) => e.id !== id)
            addRipple(element, binding.value)
        },
        beforeUnmount(element) {
            const id = element.dataset.rippleId
            state.elements = state.elements.filter((e) => e.id !== id)
        },
    },
}
